// extracted by mini-css-extract-plugin
export default {"header":"Header_header__bdPEP","logo_operator":"Header_logo_operator__QH5j4","logo":"Header_logo__RtlTd","dropdown":"Header_dropdown__8WHvc"};